module.exports = __webpack_public_path__ + "img/otp-code.62bed75a.jpg";